import * as React from 'react';
import '../css/full-width-panel.sass';

interface FullWidthPanelProps {
  children: React.ReactNode;
  backgroundColor?: string;
}

export default function FullWidthPanel(props: FullWidthPanelProps) {
  const { backgroundColor = '#F5F5F6' } = props;
  return (
    <>
      <div
        role="region"
        className="full-width-panel"
        style={{ backgroundColor }}
        {...props}
      >
        <div className="container">{props.children}</div>
      </div>
    </>
  );
}
